module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [(_vm.show) ? _c('div', {
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.$emit('removeModal')
      }
    }
  }, [_c('div', {
    class: [{
      'modal-mask': _vm.show_modal_mask
    }, {
      'modal-add-sidebar': _vm.show_modal_sidebar
    }]
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.clickAway),
      expression: "clickAway"
    }],
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-left"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header", function() {
    return [_vm._v("default header")]
  }), _vm._v(" "), _c('div', {
    staticClass: "font-large close-cross icon__bg-circle js-modalCloseEvent",
    on: {
      "click": _vm.removeModal
    }
  }, [_c('span', {
    staticClass: "icon-cross2 pointer js-modalCloseEvent"
  })])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", function() {
    return [_vm._v("default body")]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", function() {
    return [_c('button', {
      staticClass: "bttn bttn_simple right marg-10"
    }, [_vm._v("\n                  Ok\n                ")]), _vm._v(" "), _c('button', {
      staticClass: "bttn bttn_simple right marg-10"
    }, [_vm._v("\n                  Gem\n                ")])]
  })], 2)]), _vm._v(" "), (_vm.show_modal_sidebar) ? _c('div', {
    staticClass: "modal-right"
  }, [_c('div', {
    staticClass: "modal-sidebar"
  }, [_vm._t("sidebar")], 2)]) : _vm._e()])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-894064e0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CreateCalendars/Modal.vue
// module id = 1716
// module chunks = 1